import Experiments from '@wix/wix-experiments';

interface ConductExperimentParams {
  key: string;
  scope: string;
  entityId?: string;
}

export const conductExperiment = async ({
  key,
  scope,
  entityId,
}: ConductExperimentParams): Promise<boolean> => {
  const experiments = new Experiments({
    scope,
    ...(entityId && {
      useNewApi: true,
      requestContext: { overrideCriteria: { entityId } },
    }),
  });
  await experiments.ready();
  return experiments.enabled(key);
};
